<template>
  <div>
    <TheHeader />

    <section v-if="dadosAssociado.codsocio" id="relcontainer">
      <div class="container pb-5">
        <div class="row">
          <div class="col-12 py-4">
            <router-link class="btn-voltar d-print-none" :to="{ name: 'relatorioutilizacaoxbeneficiario' }">
              <span class="material-icons">chevron_left</span> Relatórios Planos
            </router-link>

            <h1 class="title mt-4 text-uppercase title-blue">
              RELATÓRIO DE UTILIZAÇÕES x BENEFICIÁRIO
            </h1>
          </div>

          <div class="message-box" v-if="urlParams.periodo == getCurrentYearAndMonth()">
            <img src="@/assets/img/megaphone.png" alt="Logo" class="report-logo">

            <div
              class="alert alert-warning border-0 d-flex align-items-center justify-content-between position-relative"
              role="alert">
              <p class="message">
                As informações apresentadas neste relatório podem sofrer alterações no decorrer do mês.<br>
              </p>

              <p class="message" style="font-weight: bold;">
                O RELATÓRIO OFICIAL
              </p>

              <p class="message" style="font-weight: bold;">
                Será disponibilizado após a finalização do processamento.
              </p>
            </div>
          </div>
        </div>

        <div class="row align-items-center mt-4">
          <div class="col-md-6">
            <div class="vidas-lista">
              <vue-select class="vue-select2" name="select2" :options="vidasLista" :searchable="true"
                placeholder="Selecione uma vida" language="pt" @input="buscarVida">
                <span slot="no-options"> Nenhum resultado. </span>
              </vue-select>
            </div>
          </div>

          <div class="col-md-6 mt-3 mt-md-0 text-md-right d-print-none d-flex flex-column align-items-md-end">
            <div class="d-flex flex-column gap-2">
              <button type="button" class="btn btn-outline-success font-weight-bold d-flex align-items-center justify-content-between"
                style="min-width: 210px;"
                :disabled="!temVidaSelecionada || modalEnvio.enviando" @click="baixarExcel">
                RELATÓRIO EM EXCEL
                <span class="material-icons" style="font-size:16px;margin-left:8px;">mail_outline</span>
              </button>

              <button type="button" class="btn btn-outline-danger font-weight-bold d-flex align-items-center justify-content-between"
                style="min-width: 210px;"
                :disabled="!temVidaSelecionada || modalEnvio.enviando" @click="baixarPDF">
                RELATÓRIO EM PDF
                <span class="material-icons" style="font-size:16px;margin-left:8px;">mail_outline</span>
              </button>
            </div>

            <small v-if="!temVidaSelecionada" class="text-muted mt-2">
              Selecione uma vida para liberar o envio do relatório.
            </small>
          </div>
        </div>

        <div v-if="temVidaSelecionada && gruposFamiliaSelecionados.length">
          <div class="bg-white rounded p-4 mt-4 border border-light">
            <div class="row">
              <div class="col-12">
                <div class="rel-title title-blue">ORGANIZAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.entidade }}</div>
              </div>

              <div class="col-md-4 mt-4">
                <div class="rel-title title-blue">ASSOCIADO</div>
                <div class="rel-value-reg">{{ dadosAssociado.codsocio }}</div>
              </div>

              <div class="col-md-2 mt-4">
                <div class="rel-title title-blue">DATA DA FILIAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.dtfiliacao }}</div>
              </div>

              <div class="col-md-6 mt-4">
                <div class="rel-title title-blue">ENDEREÇO</div>
                <div class="rel-value-reg">{{ dadosAssociado.endereco }}</div>
              </div>
            </div>
          </div>

          <div class="row" v-if="Object.keys(vidas).length > 1">
            <div class="col-md-4 mt-4" v-for="(item, index) in itemsTop" :key="index">
              <ItemCard ref="itemCard" :title="item.titulo" :value="String(item.valor)" />
            </div>
          </div>

          <div class="mt-5" v-if="resumoPorCategoria.length > 0">
            <h3 class="subtitle">RESUMO DE UTILIZAÇÕES</h3>

            <div class="bg-white p-0 mt-4 border border-light table-responsive">
              <table class="table table-resumo w-100 m-0">
                <thead>
                  <tr class="thead-blue">
                    <th scope="col" class="text-left" style="width: 50%;">Serviço</th>
                    <th scope="col" class="text-center" style="width: 20%;">QTD</th>
                    <th scope="col" class="text-center" style="width: 30%;">Subtotal</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, index) in resumoPorCategoria" :key="index">
                    <td class="text-left">{{ item.tipo_servico }}</td>
                    <td class="text-center">{{ item.quantidade_total }}</td>
                    <td class="text-center">{{ item.valor_total_cobrado | currency }}</td>
                  </tr>
                </tbody>

                <tfoot class="tfoot-light-blue">
                  <tr>
                    <td class="text-center pr-4 font-weight-bold">TOTAL</td>
                    <td class="text-center font-weight-bold">{{ totalResumo.quantidade_total }}</td>
                    <td class="text-center font-weight-bold">
                      {{ totalResumo.valor_total_geral | currency }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="mt-5">
            <h3 class="subtitle">RELATÓRIO POR VIDAS</h3>

            <div class="mt-3 text-muted small">
              <p></p>
            </div>

            <div v-for="(grupo, grupoIndex) in gruposFamiliaSelecionados" :key="grupoIndex" class="vida-grupo-shell grupo-familia-card">

              <div v-if="grupo.vidas.every(v => getTipoVida(v) !== 'TITULAR')"
                class="vida-grupo-titular-label">
                TITULAR: {{ getNomeTitularGrupo(grupo) }}
              </div>

              <div v-for="(vida, i) in grupo.vidas" :key="i" class="vida-table-shell">

                <div v-if="getTipoVida(vida) === 'TITULAR' && i === 0"
                  class="vida-grupo-titular-label">
                  TITULAR | {{ vida.nome }}
                </div>
                <div v-if="getTipoVida(vida) === 'DEPENDENTE' && (i === 0 || getTipoVida(grupo.vidas[i - 1]) === 'TITULAR')"
                  class="vida-grupo-dependente-label">
                  DEPENDENTE(S):
                </div>

                <div class="vida-table-inner">
                  <div class="bg-vida-header px-3 py-2 d-flex justify-content-between align-items-center flex-wrap"
                    :class="{
                      'mt-2': i === 0,
                      'bg-vida-header-titular': getTipoVida(vida) === 'TITULAR',
                      'bg-vida-header-dependente': getTipoVida(vida) === 'DEPENDENTE'
                    }">
                    <div class="font-weight-bold text-uppercase vida-header-text">
                      {{ vida.nome }} | CARTEIRINHA: {{ vida.carteira }} | DT. VIGÊNCIA: {{ getDataVigenciaVida(vida) || "-" }} | {{ getTipoVida(vida) === 'TITULAR' ? 'TITULAR' : 'DEPENDENTE' }}
                    </div>
                  </div>

                  <div class="bg-white pt-0 px-0 w-100 table-responsive lista-vida">
                    <table class="table table-vida w-100 m-0">
                      <thead>
                        <tr>
                          <th class="text-left" style="width: 55%;">SERVIÇO</th>
                          <th class="text-center" style="width: 15%;">QTD</th>
                          <th class="text-center" style="width: 15%;">UNITÁRIO</th>
                          <th class="text-center" style="width: 15%;">SUBTOTAL</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="(uso, usoIndex) in filtrarVidas(vida.codvida)" :key="usoIndex">
                          <td class="text-left">{{ getNomeServico(uso) }}</td>
                          <td class="text-center">{{ uso.quantidade }}</td>
                          <td class="text-center">{{ uso.vlrunitario | currency }}</td>
                          <td class="text-center">{{ uso.vlrtotal | currency }}</td>
                        </tr>
                      </tbody>

                      <tfoot>
                        <tr>
                          <td class="text-left font-weight-bold">SUBTOTAL:</td>
                          <td class="text-center font-weight-bold">{{ totalQuantidadeVida(vida.codvida) }}</td>
                          <td class="text-center font-weight-bold">-</td>
                          <td class="text-center font-weight-bold">{{ totalVida(vida.codvida) | currency }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div class="total-utilizacoes-titular-vidas">
                <div class="total-utilizacoes-titular-label">
                  TOTAL UTILIZAÇÕES TITULAR ({{ getNomeTitularGrupo(grupo) }})
                </div>
                <div class="total-utilizacoes-titular-valor">
                  {{ calcularTotalUtilizacoesGrupo(grupo).valorTotal | currency }}
                </div>
              </div>
            </div>

            <div class="mt-3 text-muted small">
              <p>* Esse relatório não possui validade para fins de Imposto de Renda.</p>
            </div>
          </div>
        </div>

        <div v-else-if="!temVidaSelecionada" class="card border-0 py-5 mt-4 d-flex justify-content-center align-items-center bg-light">
          <h5 class="text-muted mb-0">
            Selecione uma vida para visualizar o detalhamento.
          </h5>
        </div>
      </div>
    </section>

    <section v-else class="py-5 text-center">
      <loading />
    </section>

    <div v-if="modalEnvio.visivel" class="modal-envio-backdrop">
      <div class="modal-envio-card">
        <div class="modal-envio-header">
          <h5>Envio de relatório</h5>

          <button type="button" class="modal-envio-close" :disabled="modalEnvio.enviando" @click="fecharModalEnvio">
            ×
          </button>
        </div>

        <div class="modal-envio-body">
          <p class="mb-2">
            O relatório será encaminhado para a caixa de e-mail cadastrada do associado.
          </p>

          <div class="mb-2 d-flex align-items-center flex-wrap">
            <span class="mr-1">E-mail de envio:</span>
            <template v-if="!editandoEmailEnvio">
              <strong class="mx-1">{{ emailEditavel || emailRelatorioEnvio || "E-mail não localizado" }}</strong>
              <span class="material-icons" style="font-size:18px;cursor:pointer;color:#004E9A;" @click="iniciarEdicaoEmail">edit</span>
            </template>
            <template v-else>
              <input v-model="emailEditavel" type="email" class="form-control form-control-sm mx-1" style="width:220px;" />
              <span class="material-icons" style="font-size:18px;cursor:pointer;color:#28a745;" title="Salvar" @click="salvarEmailEditavel">check</span>
              <span class="material-icons ml-1" style="font-size:18px;cursor:pointer;color:#dc3545;" title="Cancelar" @click="cancelarEdicaoEmail">close</span>
            </template>
          </div>

          <p class="mb-2">
            Tipo de arquivo:
            <strong>{{ modalEnvio.tipo === "pdf" ? "PDF" : "Excel" }}</strong>
          </p>

          <p class="mb-0">
            Vida selecionada:
            <strong>{{ vidaSelecionada ? vidaSelecionada.label : "-" }}</strong>
          </p>

          <div v-if="modalEnvio.erro" class="alert alert-danger mt-3 mb-0">
            {{ modalEnvio.erro }}
          </div>

          <div v-if="modalEnvio.sucesso" class="alert alert-success mt-3 mb-0">
            {{ modalEnvio.sucesso }}
          </div>
        </div>

        <div class="modal-envio-footer">
          <button type="button" class="btn btn-light font-weight-bold" :disabled="modalEnvio.enviando"
            @click="fecharModalEnvio">
            CANCELAR
          </button>

          <button type="button" class="btn btn-primary font-weight-bold"
            :disabled="!podeConfirmarEnvioRelatorio" @click="confirmarEnvioRelatorio">
            {{ modalEnvio.enviando ? "ENVIANDO..." : "CONFIRMAR ENVIO" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import ItemCard from "@/components/relatorio/ItemCard";
// import IconPdf from "@/components/icones/Pdf";
import VueSelect from "vue-select";

import LogoCdlSaude from "@/assets/img/logo.png";

import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";

const REPORT_COLORS = {
  blue: "#004E9A",
  blueRgb: [0, 78, 154],

  lightBlue: "#EBF2F9",
  lightBlueRgb: [235, 242, 249],

  borderBlue: "#DBE9F7",
  borderBlueRgb: [219, 233, 247],

  textDark: "#222222",
  textDarkRgb: [34, 34, 34],

  white: "#FFFFFF",
  whiteRgb: [255, 255, 255],

  excelBlue: "FF004E9A",
  excelLightBlue: "FFEBF2F9",
  excelBorderBlue: "FFDBE9F7",
  excelWhite: "FFFFFFFF",
  excelDark: "FF222222",
  excelDependente: "FF546E7A"
};

const LOGO_CDL_SAUDE_PATH = LogoCdlSaude;

export default {
  name: "extrato-utilizacao_beneficiario",

  components: {
    VueSelect,
    TheHeader,
    ItemCard,
    // IconPdf
  },

  data() {
    return {
      total: 0,
      relData: [],
      vidas: {},
      dadosAssociado: {},
      agrupados: {},
      itemsTop: [],
      vidasLista: [],
      vidaSelecionada: null,
      resumoUtilizacoesApi: [],

      modalEnvio: {
        visivel: false,
        tipo: null,
        enviando: false,
        erro: "",
        sucesso: ""
      },

      editandoEmailEnvio: false,
      emailEditavel: ""
    };
  },

  filters: {
    filterData(val) {
      if (!val) return "";
      return String(val).replace(/\//g, "-");
    },

    currency(valor) {
      const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      });

      return formatter.format(valor || 0);
    }
  },

  props: {
    tipo: String,
    periodo: String
  },

  computed: {
    urlParams() {
      return this.$route.params;
    },

    temVidaSelecionada() {
      return !!this.vidaSelecionada;
    },

    vidasOrdenadas() {
      return Object.values(this.vidas);
    },

    gruposFamiliaSelecionados() {
      const registros = this.getRegistrosSelecionados();
      if (!registros.length) return [];
      return this.montarGruposFamiliaNoFront(registros);
    },

    emailRelatorioEnvio() {
      return this.obterEmailAssociadoEnvio();
    },

    podeConfirmarEnvioRelatorio() {
      return !this.modalEnvio.enviando && !this.modalEnvio.sucesso && !this.editandoEmailEnvio;
    },

    resumoPorCategoria() {
      if (this.resumoUtilizacoesApi && this.resumoUtilizacoesApi.length > 0) {
        return this.resumoUtilizacoesApi;
      }

      if (!this.relData || !this.relData.length) return [];

      const grupoMap = {};
      this.relData.forEach(item => {
        const tipoServico = (
          this.obterCampoApi(item, [
            "TIPO_SERVICO", "tipo_servico", "tipoServico",
            "tipO_SERVICO", "tipo"
          ]) ||
          this.getNomeServico(item) ||
          "OUTROS"
        ).trim();

        const quantidade = Number(item.quantidade) || 1;
        const valor = Number(item.vlrtotal) || Number(item.vlr_total) || 0;

        if (!grupoMap[tipoServico]) {
          grupoMap[tipoServico] = {
            tipo_servico: tipoServico,
            quantidade_total: 0,
            valor_total_cobrado: 0,
            valor_total_geral: 0
          };
        }
        grupoMap[tipoServico].quantidade_total += quantidade;
        grupoMap[tipoServico].valor_total_cobrado += valor;
        grupoMap[tipoServico].valor_total_geral += valor;
      });

      return Object.values(grupoMap).sort((a, b) =>
        String(a.tipo_servico).localeCompare(String(b.tipo_servico))
      );
    },

    totalResumo() {
      const total = this.resumoPorCategoria.reduce(
        (acumulador, atual) => {
          acumulador.quantidade_total += Number(atual.quantidade_total) || 0;
          acumulador.valor_total_cobrado += Number(atual.valor_total_cobrado) || 0;

          acumulador.valor_total_geral += Number(atual.valor_total_geral) || 0;

          return acumulador;
        },
        {
          quantidade_total: 0,
          valor_total_cobrado: 0,
          valor_total_geral: 0,

          // Mantém compatibilidade com pontos antigos do PDF/Excel.
          quantidade: 0,
          valor_total: 0
        }
      );

      total.quantidade = total.quantidade_total;

      if (!total.valor_total_geral) {
        total.valor_total_geral = total.valor_total_cobrado;
      }

      total.valor_total = total.valor_total_geral;

      return total;
    }
  },

  methods: {
    obterCampoApi(objeto, nomes) {
      if (!objeto) return null;

      for (const nome of nomes) {
        if (objeto[nome] !== undefined && objeto[nome] !== null) {
          return objeto[nome];
        }
      }

      const normalizar = valor =>
        String(valor)
          .replace(/_/g, "")
          .toLowerCase();

      const chaves = Object.keys(objeto);

      for (const nome of nomes) {
        const chaveNormalizada = normalizar(nome);
        const chaveEncontrada = chaves.find(chave => normalizar(chave) === chaveNormalizada);

        if (
          chaveEncontrada &&
          objeto[chaveEncontrada] !== undefined &&
          objeto[chaveEncontrada] !== null
        ) {
          return objeto[chaveEncontrada];
        }
      }

      return null;
    },

    normalizarNumeroApi(valor) {
      if (valor === null || valor === undefined || valor === "") return 0;
      if (typeof valor === "number") return valor;

      return Number(
        String(valor)
          .replace("R$", "")
          .replace(/\./g, "")
          .replace(",", ".")
          .trim()
      ) || 0;
    },

    normalizarResumoUtilizacoesApi(payload) {
      const lista = Array.isArray(payload)
        ? payload
        : this.obterCampoApi(payload, [
          "resumoUtilizacoes",
          "resumo_utilizacoes",
          "RESUMO_UTILIZACOES",
          "resumO_UTILIZACOES",
          "resumoUtilizacaoBeneficiarioAgrupado",
          "relatorioResumoUtilizacaoBeneficiarioAgrupado",
          "agrupado",
          "resumo",
          "lista",
          "dados",
          "data"
        ]);

      if (!Array.isArray(lista)) return [];

      // A API retorna linhas individuais; agrupa por TIPO_SERVICO e soma no front
      const grupoMap = {};

      lista.forEach(item => {
        const tipoServico = String(
          this.obterCampoApi(item, [
            "tipoServico",
            "tipo_servico",
            "TIPO_SERVICO",
            "tipO_SERVICO",
            "tipo"
          ]) || "OUTROS"
        ).trim();

        const quantidade = this.normalizarNumeroApi(
          this.obterCampoApi(item, [
            "quantidadeTotal",
            "quantidade_total",
            "QUANTIDADE_TOTAL",
            "quantidadE_TOTAL",
            "quantidade",
            "QUANTIDADE"
          ])
        );

        const valorCobrado = this.normalizarNumeroApi(
          this.obterCampoApi(item, [
            "VLR_TOTAL_COBRADO",
            "vlrTotalCobrado",
            "vlr_total_cobrado",
            "VALOR_TOTAL_COBRADO",
            "valorTotalCobrado",
            "valor_total_cobrado",
            "vlrTotal",
            "vlr_total",
            "valorTotal",
            "valor_total"
          ])
        );

        if (!grupoMap[tipoServico]) {
          grupoMap[tipoServico] = {
            tipo_servico: tipoServico,
            quantidade_total: 0,
            valor_total_cobrado: 0,
            valor_total_geral: 0
          };
        }

        grupoMap[tipoServico].quantidade_total += quantidade;
        grupoMap[tipoServico].valor_total_cobrado += valorCobrado;
        grupoMap[tipoServico].valor_total_geral += valorCobrado;
      });

      return Object.values(grupoMap).sort((a, b) =>
        String(a.tipo_servico).localeCompare(String(b.tipo_servico))
      );
    },

    carregarResumoUtilizacoesApi() {
      const url = `/api/CdlBh/RelatorioResumoUtilizacaoBeneficiarioAgrupado?AnoMes=${this.urlParams.periodo}&tipoPeriodo=0`;

      return this.$http
        .get(url)
        .then(response => {
          this.resumoUtilizacoesApi = this.normalizarResumoUtilizacoesApi(response.data);
        })
        .catch(() => {
          if (!this.resumoUtilizacoesApi || !this.resumoUtilizacoesApi.length) {
            this.resumoUtilizacoesApi = [];
          }
        });
    },

    getRelatorio() {
      this.$http
        .get(`/api/CdlBh/RelatorioResumoUtilizacaoBeneficiario?AnoMes=${this.urlParams.periodo}&tipoPeriodo=0`)
        .then(response => {
          this.relData = response.data.coparticipacao || [];
          this.dadosAssociado = response.data || {};
          this.resumoUtilizacoesApi = this.normalizarResumoUtilizacoesApi(response.data);

          this.vidasLista = [];


          this.relData.forEach(el => {
            const temVida = this.vidasLista.filter(vida => vida.value == el.codvida);

            if (temVida.length === 0) {
              const nomePessoa = el.vida || el.VIDA || el.pf || el.PF || el.nome || "";
              const tipo = el.tipo_dependencia || el.TIPO_DEPENDENCIA ||
                this.getTipoVida(this.montarVida(el));

              let labelVida;
              if (tipo === "TITULAR") {
                labelVida = `${nomePessoa} - (Titular)`;
              } else {
                let nomeTitular = this.obterCampoApi(el, [
                  "TITULAR_RESPONSAVEL",
                  "titulaR_RESPONSAVEL",
                  "titular_responsavel",
                  "titularresponsavel",
                  "titularResponsavel",
                  "nomeTitular",
                  "nome_titular"
                ]) || "";

                if (!nomeTitular) {
                  const codTitular = this.obterCampoApi(el, [
                    "CODTITULAR_RESPONSAVEL",
                    "codtitularresponsavel",
                    "codTitularResponsavel",
                    "codTitular",
                    "cod_titular",
                    "codtitular"
                  ]);
                  const regTitular = codTitular
                    ? this.relData.find(r => String(r.codvida) === String(codTitular))
                    : null;
                  nomeTitular = regTitular
                    ? (regTitular.vida || regTitular.VIDA || regTitular.pf || regTitular.PF || regTitular.nome || "")
                    : "";
                }

                labelVida = `${nomePessoa} (Dependente) - Titular: ${nomeTitular}`;
              }

              this.vidasLista.push({
                label: labelVida,
                value: el.codvida
              });
            }
          });

          this.vidasLista.sort(function (x, y) {
            return x.label == y.label ? 0 : x.label > y.label ? 1 : -1;
          });

          this.vidasLista.unshift({
            label: "TODOS",
            value: 0
          });
        })
        .then(() => {
          this.total = 0;

          this.relData.forEach(el => {
            this.total += Number(el.vlrtotal) || 0;
          });
        })
        .then(() => {
          this.itemsTop = [
            {
              titulo: "Período",
              valor: this.formatDate(this.urlParams.periodo)
            },
          ];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCurrentYearAndMonth() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const formattedMonth = month < 10 ? `0${month}` : month;

      return `${year}-${formattedMonth}`;
    },

    getRegistrosSelecionados() {
      if (!this.vidaSelecionada) return [];

      if (this.vidaSelecionada.value == 0) {
        return this.relData;
      }

      const registrosVida = this.relData.filter(
        item => item.codvida == this.vidaSelecionada.value
      );

      if (!registrosVida.length) return [];

      // Expandir para o grupo familiar completo via CODTITULAR_RESPONSAVEL
      const primeiroRegistro = registrosVida[0];
      const codTitularFamilia = this.obterCampoApi(primeiroRegistro, [
        "CODTITULAR_RESPONSAVEL",
        "codtitularresponsavel",
        "codTitularResponsavel"
      ]);

      if (!codTitularFamilia) return registrosVida;

      return this.relData.filter(item => {
        const codTitularItem = this.obterCampoApi(item, [
          "CODTITULAR_RESPONSAVEL",
          "codtitularresponsavel",
          "codTitularResponsavel"
        ]);
        return String(codTitularItem) === String(codTitularFamilia);
      });
    },

    montarGruposFamiliaNoFront(registros) {
      const gruposMap = {};
      const ordemGrupos = [];
      let chaveGrupoAtual = null;

      registros.forEach(item => {
        const vida = this.montarVida(item);
        const codVida = String(vida.codvida);
        const tipoVida = this.getTipoVida(vida);

        const codTitular = this.obterCampoApi(item, [
          "CODTITULAR_RESPONSAVEL",
          "codtitularresponsavel",
          "codTitularResponsavel",
          "codTitular",
          "cod_titular",
          "codtitular",
          "codVidaTitular",
          "cod_vida_titular"
        ]);

        const nomeTitularApi = this.obterCampoApi(item, [
          "TITULAR_RESPONSAVEL",
          "titulaR_RESPONSAVEL",
          "titular_responsavel",
          "titularresponsavel",
          "titularResponsavel",
          "nomeTitular",
          "nome_titular"
        ]);

        const codTitularStr = codTitular != null ? String(codTitular).trim() : "";

        let chaveGrupo;
        if (codTitularStr && codTitularStr !== "0") {
          // Tem CODTITULAR_RESPONSAVEL: usa o código (funciona após o backend ser atualizado)
          chaveGrupo = `titular_${codTitularStr}`;
          chaveGrupoAtual = chaveGrupo;
        } else if (tipoVida === "TITULAR") {
          // É titular: sempre usa o próprio codvida como chave e registra o grupo atual
          chaveGrupo = `titular_${codVida}`;
          chaveGrupoAtual = chaveGrupo;
        } else if (nomeTitularApi && String(nomeTitularApi).trim()) {
          // Dependente com TITULAR_RESPONSAVEL: agrupa pelo nome
          chaveGrupo = `nome_${String(nomeTitularApi).trim().toUpperCase()}`;
        } else if (chaveGrupoAtual) {
          // Dependente sem nenhum identificador: entra no grupo da última titular processada
          // (o SQL ORDER BY garante que titulares vêm antes dos seus dependentes)
          chaveGrupo = chaveGrupoAtual;
        } else {
          chaveGrupo = `vida_${codVida}`;
        }

        if (!gruposMap[chaveGrupo]) {
          gruposMap[chaveGrupo] = {
            nomeGrupo: nomeTitularApi || (tipoVida === "TITULAR" ? vida.nome : ""),
            vidasMap: {},
            vidasOrdem: []
          };
          ordemGrupos.push(chaveGrupo);
        }

        // Preferir sempre o nome da titular para nomeGrupo
        if (!gruposMap[chaveGrupo].nomeGrupo || tipoVida === "TITULAR") {
          const candidato = nomeTitularApi || (tipoVida === "TITULAR" ? vida.nome : "");
          if (candidato) gruposMap[chaveGrupo].nomeGrupo = candidato;
        }

        if (!gruposMap[chaveGrupo].vidasMap[codVida]) {
          gruposMap[chaveGrupo].vidasMap[codVida] = vida;
          gruposMap[chaveGrupo].vidasOrdem.push(codVida);
        }
      });

      return ordemGrupos
        .map(chave => {
          const grupo = gruposMap[chave];
          const vidas = grupo.vidasOrdem
            .map(codVida => grupo.vidasMap[codVida])
            .sort((a, b) => {
              const tipoA = this.getTipoVida(a) === "TITULAR" ? 0 : 1;
              const tipoB = this.getTipoVida(b) === "TITULAR" ? 0 : 1;
              if (tipoA !== tipoB) return tipoA - tipoB;
              return String(a.nome || "").localeCompare(String(b.nome || ""));
            });

          const titular = vidas.find(v => this.getTipoVida(v) === "TITULAR");

          return {
            nomeGrupo: grupo.nomeGrupo || (titular ? titular.nome : "") || (vidas[0] ? vidas[0].nome : ""),
            vidas
          };
        })
        .filter(g => g.vidas.length > 0);
    },

    calcularTotalUtilizacoesGrupo(grupo) {
      if (!grupo || !grupo.vidas) return { quantidade: 0, valorTotal: 0 };

      return grupo.vidas.reduce(
        (acc, vida) => {
          this.filtrarVidas(vida.codvida).forEach(uso => {
            acc.quantidade += Number(uso.quantidade) || 1;
            acc.valorTotal += Number(uso.vlrtotal) || 0;
          });
          return acc;
        },
        { quantidade: 0, valorTotal: 0 }
      );
    },

    getNomeTitularGrupo(grupo) {
      if (!grupo) return "";
      return String(
        grupo.nomeGrupo ||
        (grupo.vidas && grupo.vidas[0] ? grupo.vidas[0].nome : "") ||
        "NÃO INFORMADO"
      ).toUpperCase();
    },

    obterEmailAssociadoEnvio() {
      const cadastro =
        this.$user && this.$user.dadosCadastraisAssociado
          ? this.$user.dadosCadastraisAssociado[0] || {}
          : {};

      return cadastro.email || this.dadosAssociado.email || "";
    },

    getNomeServico(item) {
      return item.descrservico || item.servico || "Sem Descrição";
    },

    montarVida(registro) {
      return {
        codvida: registro.codvida || registro.CODVIDA,
        nome: registro.vida || registro.VIDA || registro.pf || registro.PF || registro.nome || "",
        carteira: registro.numcarteira || registro.NUMCARTEIRA,
        registroOriginal: registro
      };
    },

    obterRegistroVida(vida) {
      if (!vida) return {};

      if (vida.registroOriginal) {
        return vida.registroOriginal;
      }

      return this.relData.find(item => item.codvida === vida.codvida) || {};
    },

    obterCampoVida(vida, nomes) {
      const valorVida = this.obterCampoApi(vida, nomes);

      if (valorVida !== undefined && valorVida !== null && valorVida !== "") {
        return valorVida;
      }

      return this.obterCampoApi(this.obterRegistroVida(vida), nomes);
    },

    normalizarTextoComparacao(valor) {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toUpperCase();
    },

    normalizarTipoVida(valor) {
      const texto = this.normalizarTextoComparacao(valor);

      if (!texto) return "";

      if (texto === "T" || texto === "TIT" || texto.includes("TITULAR")) {
        return "TITULAR";
      }

      if (texto === "D" || texto === "DEP" || texto.includes("DEPEND")) {
        return "DEPENDENTE";
      }

      const termosDependente = [
        "CONJUGE",
        "ESPOS",
        "FILH",
        "MAE",
        "PAI",
        "IRMA",
        "NET",
        "ENTEAD",
        "AGREGAD",
        "COMPANHEIR"
      ];

      if (termosDependente.some(termo => texto.includes(termo))) {
        return "DEPENDENTE";
      }

      return "";
    },

    valorBooleanoApi(valor) {
      if (valor === true || valor === 1) return true;
      if (valor === false || valor === 0) return false;

      const texto = this.normalizarTextoComparacao(valor);

      if (["S", "SIM", "TRUE", "1", "T"].includes(texto)) return true;
      if (["N", "NAO", "FALSE", "0", "F"].includes(texto)) return false;

      return null;
    },

    getTipoVida(vida) {
      const tipo = this.normalizarTipoVida(
        this.obterCampoVida(vida, [
          "TIPO_DEPENDENCIA"
        ])
      );

      if (tipo) return tipo;

      const titular = this.valorBooleanoApi(
        this.obterCampoVida(vida, [
          "titular",
          "isTitular",
          "is_titular",
          "indTitular",
          "ind_titular",
          "indicadorTitular",
          "indicador_titular",
          "flgTitular",
          "flg_titular",
          "snTitular",
          "sn_titular"
        ])
      );

      if (titular === true) return "TITULAR";
      if (titular === false) return "DEPENDENTE";

      const dependente = this.valorBooleanoApi(
        this.obterCampoVida(vida, [
          "dependente",
          "isDependente",
          "is_dependente",
          "indDependente",
          "ind_dependente",
          "indicadorDependente",
          "indicador_dependente",
          "flgDependente",
          "flg_dependente",
          "snDependente",
          "sn_dependente"
        ])
      );

      if (dependente === true) return "DEPENDENTE";
      if (dependente === false) return "TITULAR";

      const codTitular = this.obterCampoVida(vida, [
        "codTitular",
        "cod_titular",
        "codtitular",
        "codVidaTitular",
        "cod_vida_titular",
        "codvidatitular",
        "codDependenteTitular",
        "cod_dependente_titular"
      ]);

      if (codTitular !== undefined && codTitular !== null && codTitular !== "") {
        return String(codTitular) === String(vida.codvida) ? "TITULAR" : "DEPENDENTE";
      }

      return "";
    },

    vidaEhDependente(vida) {
      return this.getTipoVida(vida) === "DEPENDENTE";
    },

    deveExibirSeparadorVida(index) {
      if (index >= this.vidasOrdenadas.length - 1) return false;

      const proximaVida = this.vidasOrdenadas[index + 1];

      return !this.vidaEhDependente(proximaVida);
    },

    formatarDataVida(valor) {
      if (!valor) return "";

      const texto = String(valor).trim();
      const dataIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);

      if (dataIso) {
        return `${dataIso[3]}/${dataIso[2]}/${dataIso[1]}`;
      }

      const dataCompacta = texto.match(/^(\d{4})(\d{2})(\d{2})$/);

      if (dataCompacta) {
        return `${dataCompacta[3]}/${dataCompacta[2]}/${dataCompacta[1]}`;
      }

      return texto;
    },

    getDataVigenciaVida(vida) {
      return this.formatarDataVida(
        this.obterCampoVida(vida, [
          "dtVigencia",
          "dt_vigencia",
          "DTVIGENCIA",
          "dataVigencia",
          "data_vigencia",
          "DATA_VIGENCIA",
          "vigencia",
          "vigência",
          "inicioVigencia",
          "inicio_vigencia",
          "dtInicioVigencia",
          "dt_inicio_vigencia",
          "dtinicioVigencia",
          "dtiniciovigencia",
          "dtInicio",
          "dt_inicio",
          "dataInicio",
          "data_inicio"
        ])
      );
    },

    getTextoCabecalhoVida(vida) {
      const tipo = this.getTipoVida(vida) === "TITULAR" ? "TITULAR" : "DEPENDENTE";
      return `${vida.nome} | CARTEIRINHA: ${vida.carteira} | DT. VIGÊNCIA: ${this.getDataVigenciaVida(vida) || "-"} | ${tipo}`;
    },

    totalQuantidadeVida(codvida) {
      return this.filtrarVidas(codvida).reduce((total, item) => {
        return total + (Number(item.quantidade) || 1);
      }, 0);
    },

    filtrarVidas(codvida) {
      const registrosVida = this.relData.filter(el => el.codvida === codvida);
      const agrupados = {};

      registrosVida.forEach(item => {
        const nomeServico = this.getNomeServico(item);
        const vlrUnitario = Number(item.vlrunitario) || 0;
        const chaveGrupo = `${nomeServico}_${vlrUnitario}`;

        if (!agrupados[chaveGrupo]) {
          agrupados[chaveGrupo] = {
            ...item,
            descrservico: nomeServico,
            quantidade: Number(item.quantidade) || 1,
            vlrunitario: vlrUnitario,
            vlrtotal: Number(item.vlrtotal) || 0
          };
        } else {
          agrupados[chaveGrupo].quantidade += Number(item.quantidade) || 1;
          agrupados[chaveGrupo].vlrtotal += Number(item.vlrtotal) || 0;
        }
      });

      return Object.values(agrupados);
    },

    buscarVida(prop) {
      this.vidas = {};
      this.vidaSelecionada = prop || null;

      if (!prop) return;

      if (prop.value == 0) {
        this.relData.forEach(el => {
          this.vidas[el.codvida] = this.montarVida(el);
        });
      } else {
        const result = this.relData.filter(el => el.codvida === prop.value);

        if (!result.length) return;

        this.vidas[result[0].codvida] = this.montarVida(result[0]);
      }
    },

    totalVida(codvida) {
      const servicos = this.relData.filter(el => el.codvida === codvida);

      return servicos.reduce((total, item) => {
        return total + (Number(item.vlrtotal) || 0);
      }, 0);
    },

    formatDate(date) {
      if (!date) return "";

      const ano = date.substr(0, 4);
      const mes = this.getMes(date.substr(5, 2));

      return `${mes} / ${ano}`;
    },

    getMes(mes) {
      const m = parseInt(mes) - 1;
      return this.$store.state.calendarOpts.pt.monthNames[m];
    },

    getDadosAssociadoExportacao() {
      const cadastro =
        this.$user && this.$user.dadosCadastraisAssociado
          ? this.$user.dadosCadastraisAssociado[0] || {}
          : {};

      return {
        codSocio: cadastro.codsociO_TEMP || this.dadosAssociado.codsocio || "",
        nomeComercial:
          cadastro.nomecomercial ||
          this.dadosAssociado.nomefantasia ||
          this.dadosAssociado.entidade ||
          ""
      };
    },

    getOperadoraInfo() {
      const primeiroRegistro = this.relData && this.relData.length ? this.relData[0] : {};

      return {
        operadora:
          this.dadosAssociado.operadora ||
          primeiroRegistro.operadora ||
          "UNIMED - BELO HORIZONTE / COOPERATIVA DE TRABALHO MEDICO LTDA.",

        cnpj:
          this.dadosAssociado.cnpjoperadora ||
          this.dadosAssociado.cnpj ||
          "16.513.178/0001-76",

        ans:
          this.dadosAssociado.ans ||
          this.dadosAssociado.registroans ||
          "34.388-9"
      };
    },

    extractSvgSize(svgText) {
      const widthMatch = svgText.match(/\swidth=["']([\d.]+)(px)?["']/i);
      const heightMatch = svgText.match(/\sheight=["']([\d.]+)(px)?["']/i);
      const viewBoxMatch = svgText.match(/\sviewBox=["']([\d.\-\s]+)["']/i);

      let width = widthMatch ? parseFloat(widthMatch[1]) : 0;
      let height = heightMatch ? parseFloat(heightMatch[1]) : 0;

      if ((!width || !height) && viewBoxMatch) {
        const viewBoxParts = viewBoxMatch[1]
          .trim()
          .split(/\s+/)
          .map(item => parseFloat(item));

        if (viewBoxParts.length === 4) {
          width = width || viewBoxParts[2];
          height = height || viewBoxParts[3];
        }
      }

      if (!width || !height) {
        width = 360;
        height = 120;
      }

      return {
        width,
        height
      };
    },

    getContainSize(originalWidth, originalHeight, maxWidth, maxHeight) {
      if (!originalWidth || !originalHeight) {
        return {
          width: maxWidth,
          height: maxHeight
        };
      }

      const ratio = Math.min(maxWidth / originalWidth, maxHeight / originalHeight);

      return {
        width: originalWidth * ratio,
        height: originalHeight * ratio
      };
    },

    async imageUrlToBase64(url) {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Logo não encontrada.");
      }

      const blob = await response.blob();
      const isSvg =
        blob.type.includes("svg") ||
        String(url).toLowerCase().includes(".svg");

      if (isSvg) {
        const svgText = await blob.text();
        return await this.svgTextToPngBase64(svgText);
      }

      return await this.blobToBase64(blob);
    },

    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => {
          const dataUrl = reader.result;
          const img = new Image();

          img.onload = () => {
            resolve({
              dataUrl,
              width: img.naturalWidth || 1,
              height: img.naturalHeight || 1
            });
          };

          img.onerror = reject;
          img.src = dataUrl;
        };

        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    svgTextToPngBase64(svgText) {
      return new Promise((resolve, reject) => {
        const size = this.extractSvgSize(svgText);

        const svgBlob = new Blob([svgText], {
          type: "image/svg+xml;charset=utf-8"
        });

        const svgUrl = URL.createObjectURL(svgBlob);
        const img = new Image();

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const width = size.width || img.naturalWidth || 360;
          const height = size.height || img.naturalHeight || 120;

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);

          URL.revokeObjectURL(svgUrl);

          resolve({
            dataUrl: canvas.toDataURL("image/png"),
            width,
            height
          });
        };

        img.onerror = (error) => {
          URL.revokeObjectURL(svgUrl);
          reject(error);
        };

        img.src = svgUrl;
      });
    },

    async addPdfHeader(doc, y, margin, now, dadosExportacao) {
      const pageWidth = doc.internal.pageSize.getWidth();
      const headerStartY = y;
      const info = this.getOperadoraInfo();

      const dataGeracao = now.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });

      try {
        const logo = await this.imageUrlToBase64(LOGO_CDL_SAUDE_PATH);

        const maxLogoWidth = 105;
        const maxLogoHeight = 36;

        const logoSize = this.getContainSize(
          logo.width,
          logo.height,
          maxLogoWidth,
          maxLogoHeight
        );

        const logoX = margin + 8;
        const logoY = headerStartY + 4 + (maxLogoHeight - logoSize.height) / 2;

        doc.addImage(
          logo.dataUrl,
          "PNG",
          logoX,
          logoY,
          logoSize.width,
          logoSize.height
        );
      } catch (error) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(21);
        doc.setTextColor(...REPORT_COLORS.blueRgb);
        doc.text("CDL", margin + 12, headerStartY + 22);

        doc.setFontSize(12);
        doc.setTextColor(230, 80, 120);
        doc.text("Saúde", margin + 12, headerStartY + 38);
      }

      const textCenterX = pageWidth / 2 + 35;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.setTextColor(...REPORT_COLORS.blueRgb);
      doc.text("RELATÓRIO - UTILIZAÇÕES X BENEFICIÁRIO", textCenterX, headerStartY + 12, {
        align: "center"
      });

      doc.setFontSize(7.8);
      doc.setTextColor(90, 90, 90);
      doc.text(`OPERADORA: ${String(info.operadora).toUpperCase()} |`, textCenterX, headerStartY + 28, {
        align: "center"
      });

      doc.text(
        `CNPJ: ${info.cnpj} | ANS - Nº ${info.ans} | GERADO EM: ${dataGeracao}`,
        textCenterX,
        headerStartY + 43,
        {
          align: "center"
        }
      );

      doc.setDrawColor(...REPORT_COLORS.blueRgb);
      doc.setLineWidth(1.2);
      doc.line(margin, headerStartY + 56, pageWidth - margin, headerStartY + 56);

      const socioTexto = dadosExportacao.codSocio
        ? `SÓCIO: ${dadosExportacao.codSocio} - ${dadosExportacao.nomeComercial}`
        : `SÓCIO: ${dadosExportacao.nomeComercial}`;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(...REPORT_COLORS.blueRgb);
      doc.text(String(socioTexto).toUpperCase(), margin, headerStartY + 95);

      doc.setDrawColor(...REPORT_COLORS.blueRgb);
      doc.setLineWidth(1.2);
      doc.line(margin, headerStartY + 110, pageWidth - margin, headerStartY + 110);

      return headerStartY + 120;
    },

    getPdfBaseTableStyles(fontSize) {
      return {
        theme: "grid",
        headStyles: {
          fillColor: REPORT_COLORS.lightBlueRgb,
          textColor: REPORT_COLORS.blueRgb,
          fontStyle: "bold",
          fontSize,
          halign: "center",
          lineColor: REPORT_COLORS.borderBlueRgb,
          lineWidth: 0.5,
          cellPadding: 5
        },
        bodyStyles: {
          textColor: REPORT_COLORS.textDarkRgb,
          fontSize,
          lineColor: REPORT_COLORS.borderBlueRgb,
          lineWidth: 0.5,
          cellPadding: 5
        },
        footStyles: {
          fillColor: REPORT_COLORS.lightBlueRgb,
          textColor: REPORT_COLORS.blueRgb,
          fontStyle: "bold",
          fontSize,
          lineColor: REPORT_COLORS.borderBlueRgb,
          lineWidth: 0.5,
          cellPadding: 5
        },
        alternateRowStyles: {
          fillColor: [255, 255, 255]
        }
      };
    },

    addBluePdfBlock(doc, y, margin, text, fontSize = 9) {
      const pageWidth = doc.internal.pageSize.getWidth();
      const tableWidth = pageWidth - margin * 2;

      autoTable(doc, {
        startY: y,
        theme: "plain",
        tableWidth,
        body: [[String(text).toUpperCase()]],
        bodyStyles: {
          fillColor: REPORT_COLORS.blueRgb,
          textColor: REPORT_COLORS.whiteRgb,
          fontStyle: "bold",
          fontSize,
          halign: "left",
          cellPadding: 7
        },
        columnStyles: {
          0: {
            cellWidth: tableWidth
          }
        },
        margin: {
          left: margin,
          right: margin
        }
      });

      return doc.lastAutoTable.finalY;
    },

    addTitleBluePdf(doc, y, margin, text, fontSize = 11) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(fontSize);
      doc.setTextColor(...REPORT_COLORS.blueRgb);
      doc.text(String(text).toUpperCase(), margin, y + 15);
      return y + 25;
    },

    iniciarEdicaoEmail() {
      this.emailEditavel = this.emailRelatorioEnvio || "";
      this.editandoEmailEnvio = true;
    },

    salvarEmailEditavel() {
      this.emailEditavel = String(this.emailEditavel || "").trim();
      this.editandoEmailEnvio = false;
    },

    cancelarEdicaoEmail() {
      this.emailEditavel = "";
      this.editandoEmailEnvio = false;
    },

    baixarPDF() {
      this.abrirModalEnvio("pdf");
    },

    baixarExcel() {
      this.abrirModalEnvio("excel");
    },

    abrirModalEnvio(tipo) {
      if (!this.temVidaSelecionada) return;

      this.editandoEmailEnvio = false;

      this.modalEnvio = {
        visivel: true,
        tipo,
        enviando: false,
        erro: "",
        sucesso: ""
      };
    },

    fecharModalEnvio() {
      if (this.modalEnvio.enviando) return;

      this.editandoEmailEnvio = false;
      this.emailEditavel = "";

      this.modalEnvio = {
        visivel: false,
        tipo: null,
        enviando: false,
        erro: "",
        sucesso: ""
      };
    },

    async confirmarEnvioRelatorio() {
      if (!this.podeConfirmarEnvioRelatorio) return;

      if (!this.temVidaSelecionada) {
        this.modalEnvio.erro = "Selecione uma vida para enviar o relatório.";
        return;
      }

      try {
        this.modalEnvio.enviando = true;
        this.modalEnvio.erro = "";
        this.modalEnvio.sucesso = "";

        const arquivo = this.modalEnvio.tipo === "pdf"
          ? await this.gerarPdfBlob()
          : await this.gerarExcelBlob();

        const response = await this.enviarRelatorioPorEmail({
          blob: arquivo.blob,
          nomeArquivo: arquivo.nomeArquivo,
          tipo: this.modalEnvio.tipo
        });

        const dadosResposta = response && response.data ? response.data : {};

        const emailEnviado =
          dadosResposta.emailEnviado ||
          dadosResposta.EmailEnviado ||
          dadosResposta.email ||
          dadosResposta.Email ||
          "";

        this.modalEnvio.sucesso = emailEnviado
          ? `Relatório enviado com sucesso para o e-mail ${emailEnviado}.`
          : "Relatório enviado com sucesso para o e-mail cadastrado.";
      } catch (error) {
        console.error(error);

        this.modalEnvio.erro =
          error &&
            error.response &&
            error.response.data &&
            error.response.data.message
            ? error.response.data.message
            : "Não foi possível enviar o relatório por e-mail.";
      } finally {
        this.modalEnvio.enviando = false;
      }
    },

    async enviarRelatorioPorEmail({ blob, nomeArquivo, tipo }) {
      const dadosExportacao = this.getDadosAssociadoExportacao();
      const formData = new FormData();

      formData.append("arquivo", blob, nomeArquivo);
      formData.append("tipo", tipo);
      formData.append("periodo", this.urlParams.periodo || "");
      formData.append("codSocio", dadosExportacao.codSocio || "");
      formData.append("nomeAssociado", dadosExportacao.nomeComercial || "");
      formData.append("emailAssociado", this.emailEditavel || this.emailRelatorioEnvio || "");
      formData.append("vidaSelecionada", this.vidaSelecionada ? this.vidaSelecionada.label : "");
      formData.append("codVida", this.vidaSelecionada ? this.vidaSelecionada.value : "");

      return this.$http.post(
        "/api/CdlBh/EnviarRelatorioUtilizacaoBeneficiarioEmail",
        formData
      );
    },

    async gerarPdfBlob() {
      const doc = new jsPDF("p", "pt", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 40;
      const tableWidth = pageWidth - margin * 2;
      let y = 50;

      const now = new Date();
      const dadosExportacao = this.getDadosAssociadoExportacao();

      y = await this.addPdfHeader(doc, y, margin, now, dadosExportacao);

      if (this.resumoPorCategoria.length > 0) {
        y = this.addTitleBluePdf(doc, y, margin, "RESUMO DE UTILIZAÇÕES", 11);

        const linhasResumo = this.resumoPorCategoria.map(item => [
          String(item.tipo_servico || "OUTROS").toUpperCase(),
          item.quantidade_total,
          this.$options.filters.currency(item.valor_total_cobrado)
        ]);

        autoTable(doc, {
          startY: y,
          tableWidth,
          head: [["SERVIÇO", "QTD", "SUBTOTAL"]],
          body: linhasResumo,
          foot: [[
            { content: "TOTAL", styles: { halign: "center" } },
            { content: this.totalResumo.quantidade_total, styles: { halign: "center" } },
            { content: this.$options.filters.currency(this.totalResumo.valor_total_geral), styles: { halign: "center" } }
          ]],
          showHead: "everyPage",
          showFoot: "lastPage",
          rowPageBreak: "avoid",
          ...this.getPdfBaseTableStyles(8),
          columnStyles: {
            0: { cellWidth: 300, halign: "left" },
            1: { cellWidth: 85, halign: "center" },
            2: { cellWidth: 130, halign: "center" }
          },
          margin: { left: margin, right: margin }
        });

        y = doc.lastAutoTable.finalY + 15;
      }

      y = this.addTitleBluePdf(doc, y, margin, "RELATÓRIO POR VIDAS", 11);

      const addPdfLabelRowBenef = (texto) => ([
        {
          content: texto.toUpperCase(),
          colSpan: 4,
          styles: {
            fillColor: [255, 255, 255],
            textColor: REPORT_COLORS.blueRgb,
            fontStyle: "bold",
            fontSize: 9,
            halign: "left",
            cellPadding: 5
          }
        }
      ]);

      const addPdfTitularBarRowBenef = (texto) => ([
        {
          content: texto.toUpperCase(),
          colSpan: 4,
          styles: {
            fillColor: REPORT_COLORS.blueRgb,
            textColor: REPORT_COLORS.whiteRgb,
            fontStyle: "bold",
            fontSize: 9,
            halign: "left",
            cellPadding: 7
          }
        }
      ]);

      this.gruposFamiliaSelecionados.forEach((grupo) => {
        if (y > 735) {
          doc.addPage();
          y = 50;
        }

        const linhasDoGrupo = [];

        const apenasDepend = grupo.vidas.every(v => this.getTipoVida(v) !== "TITULAR");
        if (apenasDepend) {
          linhasDoGrupo.push(addPdfTitularBarRowBenef(`TITULAR: ${this.getNomeTitularGrupo(grupo)}`));
        }

        grupo.vidas.forEach((vida, vidaIndex) => {
          const tipoDep = this.getTipoVida(vida);
          const corFillVida = [84, 110, 122];
          const corTextVida = REPORT_COLORS.whiteRgb;
          const usos = this.filtrarVidas(vida.codvida);

          if (tipoDep === "TITULAR" && vidaIndex === 0) {
            linhasDoGrupo.push(addPdfTitularBarRowBenef(`TITULAR | ${vida.nome}`));
          }
          if (
            tipoDep === "DEPENDENTE" &&
            (vidaIndex === 0 || this.getTipoVida(grupo.vidas[vidaIndex - 1]) === "TITULAR")
          ) {
            linhasDoGrupo.push(addPdfLabelRowBenef("DEPENDENTE(S):"));
          }

          linhasDoGrupo.push([{
            content: this.getTextoCabecalhoVida(vida).toUpperCase(),
            colSpan: 4,
            styles: {
              fillColor: corFillVida,
              textColor: corTextVida,
              fontStyle: "bold",
              fontSize: 8,
              halign: "left",
              cellPadding: 6
            }
          }]);

          linhasDoGrupo.push([
            { content: "SERVIÇO", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "left" } },
            { content: "QTD", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "center" } },
            { content: "UNITÁRIO", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "center" } },
            { content: "SUBTOTAL", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "center" } }
          ]);

          let tQtdVida = 0;
          let tVlrVida = 0;

          usos.forEach(uso => {
            const qtd = Number(uso.quantidade) || 1;
            const valorTotal = Number(uso.vlrtotal) || 0;
            tQtdVida += qtd;
            tVlrVida += valorTotal;

            linhasDoGrupo.push([
              { content: String(this.getNomeServico(uso)).toUpperCase(), styles: { halign: "left" } },
              { content: qtd, styles: { halign: "center" } },
              { content: this.$options.filters.currency(uso.vlrunitario || 0), styles: { halign: "center" } },
              { content: this.$options.filters.currency(valorTotal), styles: { halign: "center" } }
            ]);
          });

          linhasDoGrupo.push([
            { content: "SUBTOTAL", styles: { halign: "center", fontStyle: "bold", fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb } },
            { content: tQtdVida, styles: { halign: "center", fontStyle: "bold", fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb } },
            { content: "-", styles: { halign: "center", fontStyle: "bold", fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb } },
            { content: this.$options.filters.currency(tVlrVida), styles: { halign: "center", fontStyle: "bold", fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb } }
          ]);
        });

        const totaisGrupo = this.calcularTotalUtilizacoesGrupo(grupo);
        const textoTotal = `TOTAL UTILIZAÇÕES TITULAR (${this.getNomeTitularGrupo(grupo)})`;
        const corFundoTotal = REPORT_COLORS.blueRgb;

        linhasDoGrupo.push([
          {
            content: textoTotal,
            colSpan: 3,
            styles: { fillColor: corFundoTotal, textColor: [255, 255, 255], fontStyle: "bold", halign: "left", cellPadding: 8 }
          },
          {
            content: this.$options.filters.currency(totaisGrupo.valorTotal),
            styles: { fillColor: corFundoTotal, textColor: [255, 255, 255], fontStyle: "bold", halign: "center", cellPadding: 8 }
          }
        ]);

        autoTable(doc, {
          startY: y,
          theme: "grid",
          tableWidth,
          body: linhasDoGrupo,
          pageBreak: "avoid",
          rowPageBreak: "avoid",
          styles: {
            textColor: REPORT_COLORS.textDarkRgb,
            fontSize: 8,
            lineColor: REPORT_COLORS.borderBlueRgb,
            lineWidth: 0.5,
            cellPadding: 5
          },
          columnStyles: {
            0: { cellWidth: 320 },
            1: { cellWidth: 65, halign: "center" },
            2: { cellWidth: 65, halign: "center" },
            3: { cellWidth: 65, halign: "center" }
          },
          margin: { left: margin, right: margin }
        });

        y = doc.lastAutoTable.finalY + 30;
      });

      if (y > 760) {
        doc.addPage();
        y = 50;
      }

      autoTable(doc, {
        startY: y,
        theme: "plain",
        tableWidth,
        body: [[`TOTAL DO ASSOCIADO: ${this.$options.filters.currency(this.totalResumo.valor_total || this.total)}`]],
        bodyStyles: {
          fillColor: REPORT_COLORS.lightBlueRgb,
          textColor: REPORT_COLORS.blueRgb,
          fontStyle: "bold",
          fontSize: 11,
          halign: "center",
          cellPadding: 7
        },
        columnStyles: { 0: { cellWidth: tableWidth } },
        margin: { left: margin, right: margin }
      });

      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(100, 100, 100);
      doc.text(
        "* Esse relatório não possui validade para fins de Imposto de Renda.",
        margin,
        pageHeight - 30
      );

      const nomeArquivo = `extrato_utilizacoes_beneficiario_${now.getTime()}.pdf`;

      return {
        blob: doc.output("blob"),
        nomeArquivo
      };
    },

    excelBorder() {
      return {
        top: {
          style: "thin",
          color: {
            argb: REPORT_COLORS.excelBorderBlue
          }
        },
        left: {
          style: "thin",
          color: {
            argb: REPORT_COLORS.excelBorderBlue
          }
        },
        bottom: {
          style: "thin",
          color: {
            argb: REPORT_COLORS.excelBorderBlue
          }
        },
        right: {
          style: "thin",
          color: {
            argb: REPORT_COLORS.excelBorderBlue
          }
        }
      };
    },

    styleExcelMainHeader(cell, horizontal) {
      cell.font = {
        bold: true,
        size: 12,
        color: {
          argb: REPORT_COLORS.excelWhite
        }
      };

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: REPORT_COLORS.excelBlue
        }
      };

      cell.alignment = {
        horizontal: horizontal || "center",
        vertical: "center"
      };

      cell.border = this.excelBorder();
    },

    styleExcelTableHeader(cell) {
      cell.font = {
        bold: true,
        color: {
          argb: REPORT_COLORS.excelBlue
        }
      };

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: REPORT_COLORS.excelLightBlue
        }
      };

      cell.alignment = {
        horizontal: "center",
        vertical: "center"
      };

      cell.border = this.excelBorder();
    },

    styleExcelBodyCell(cell, horizontal) {
      cell.font = {
        color: {
          argb: REPORT_COLORS.excelDark
        }
      };

      cell.alignment = {
        horizontal: horizontal || "left",
        vertical: "center"
      };

      cell.border = this.excelBorder();
    },

    styleExcelTotalCell(cell, horizontal) {
      cell.font = {
        bold: true,
        color: {
          argb: REPORT_COLORS.excelBlue
        }
      };

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: REPORT_COLORS.excelLightBlue
        }
      };

      cell.alignment = {
        horizontal: horizontal || "center",
        vertical: "center"
      };

      cell.border = this.excelBorder();
    },

    async gerarExcelBlob() {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Utilizações Beneficiário");

      sheet.properties.defaultRowHeight = 22;
      sheet.getColumn("A").width = 60;
      sheet.getColumn("B").width = 16;
      sheet.getColumn("C").width = 24;
      sheet.getColumn("D").width = 24;

      const now = new Date();
      const dataAtual = now.toLocaleString("pt-BR");
      const dataArquivo = now
        .toLocaleString("pt-BR")
        .replace(/\//g, "-")
        .replace(/:/g, "-")
        .replace(", ", "_");

      const dadosExportacao = this.getDadosAssociadoExportacao();

      const setRowValues = (rowNumber, values) => {
        for (let col = 1; col <= 4; col++) {
          sheet.getCell(rowNumber, col).value = values[col - 1] !== undefined ? values[col - 1] : "";
        }
      };

      const formatarTextoLeitura = value => {
        const texto = String(value || "").trim();
        if (!texto) return "";

        const manterMinusculo = ["a", "as", "ao", "aos", "com", "da", "das", "de", "do", "dos", "e", "em", "no", "nos", "na", "nas", "para", "por"];
        const manterMaiusculo = ["BH", "CDL", "CPF", "CNPJ", "LGPD", "SUS", "ANS"];

        return texto
          .toLocaleLowerCase("pt-BR")
          .split(/(\s+|[|/-])/)
          .map((parte, index) => {
            if (!parte.trim() || /^[|/-]$/.test(parte)) return parte;

            const parteUpper = parte.toLocaleUpperCase("pt-BR");
            if (manterMaiusculo.includes(parteUpper)) return parteUpper;
            if (index > 0 && manterMinusculo.includes(parte)) return parte;

            return parte.charAt(0).toLocaleUpperCase("pt-BR") + parte.slice(1);
          })
          .join("");
      };

      const formatMoney = cell => { cell.numFmt = '"R$" #,##0.00'; };
      const formatQuantity = cell => { cell.numFmt = "0"; };

      const styleRowMainHeader = (rowNumber, horizontal = "center") => {
        for (let col = 1; col <= 4; col++) {
          this.styleExcelMainHeader(sheet.getCell(rowNumber, col), col === 1 ? horizontal : "center");
        }
      };

      const styleRowTableHeader = rowNumber => {
        for (let col = 1; col <= 4; col++) {
          this.styleExcelTableHeader(sheet.getCell(rowNumber, col));
        }
      };

      const styleRowBody = rowNumber => {
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 1), "left");
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 2), "center");
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 3), "center");
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 4), "center");
      };

      const styleRowTotal = rowNumber => {
        for (let col = 1; col <= 4; col++) {
          this.styleExcelTotalCell(sheet.getCell(rowNumber, col), col === 1 ? "left" : "center");
        }
      };

      const addBlankRow = rowNumber => {
        for (let col = 1; col <= 4; col++) {
          const cell = sheet.getCell(rowNumber, col);
          cell.value = "";
          cell.border = undefined;
          cell.fill = undefined;
        }
        sheet.getRow(rowNumber).height = 22;
      };

      let linha = 1;

      setRowValues(linha, ["Relatório de utilizações x beneficiário", "", "", ""]);
      styleRowMainHeader(linha, "center");
      sheet.getCell(`A${linha}`).font.size = 16;
      sheet.mergeCells(linha, 1, linha, 4);
      linha++;

      setRowValues(linha, [`© CDL•BH - Gerado em: ${dataAtual}`, "", "", ""]);
      styleRowMainHeader(linha, "center");
      sheet.mergeCells(linha, 1, linha, 4);
      linha++;

      setRowValues(linha, [`Associado: ${dadosExportacao.codSocio} - ${formatarTextoLeitura(dadosExportacao.nomeComercial)}`, "", "", ""]);
      styleRowMainHeader(linha, "center");
      sheet.mergeCells(linha, 1, linha, 4);
      linha++;

      if (this.resumoPorCategoria.length > 0) {
        setRowValues(linha, ["Resumo de utilizações", "", "", ""]);
        styleRowMainHeader(linha, "center");
        sheet.mergeCells(linha, 1, linha, 4);
        linha++;

        setRowValues(linha, ["Serviço", "Qtd", "Subtotal", ""]);
        styleRowTableHeader(linha);
        linha++;

        this.resumoPorCategoria.forEach(item => {
          setRowValues(linha, [
            formatarTextoLeitura(item.tipo_servico || "OUTROS"),
            item.quantidade_total,
            item.valor_total_cobrado,
            ""
          ]);
          styleRowBody(linha);
          formatQuantity(sheet.getCell(`B${linha}`));
          formatMoney(sheet.getCell(`C${linha}`));
          linha++;
        });

        setRowValues(linha, ["Total", this.totalResumo.quantidade_total, this.totalResumo.valor_total_geral, ""]);
        styleRowTotal(linha);
        formatQuantity(sheet.getCell(`B${linha}`));
        formatMoney(sheet.getCell(`C${linha}`));
        linha++;
      }

      setRowValues(linha, ["Relatório por Vidas", "", "", ""]);
      styleRowMainHeader(linha, "center");
      sheet.mergeCells(linha, 1, linha, 4);
      linha++;

      const addExcelLabelRow = (texto, rowNum) => {
        setRowValues(rowNum, [texto, "", "", ""]);
        for (let col = 1; col <= 4; col++) {
          const cell = sheet.getCell(rowNum, col);
          cell.font = { bold: true, size: 11, color: { argb: REPORT_COLORS.excelBlue } };
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: REPORT_COLORS.excelWhite } };
          cell.alignment = { horizontal: "left", vertical: "center" };
          cell.border = this.excelBorder();
        }
        sheet.mergeCells(rowNum, 1, rowNum, 4);
      };

      const addExcelTitularBarRow = (texto, rowNum) => {
        setRowValues(rowNum, [formatarTextoLeitura(texto), "", "", ""]);
        styleRowMainHeader(rowNum, "left");
        sheet.mergeCells(rowNum, 1, rowNum, 4);
      };

      this.gruposFamiliaSelecionados.forEach((grupo, grupoIndex) => {
        const apenasDepend = grupo.vidas.every(v => this.getTipoVida(v) !== "TITULAR");
        if (apenasDepend) {
          addExcelTitularBarRow(`Titular: ${this.getNomeTitularGrupo(grupo)}`, linha);
          linha++;
        }

        grupo.vidas.forEach((vida, vidaIdx) => {
          const tipoDep = this.getTipoVida(vida);
          const nomeVida = formatarTextoLeitura(vida.nome);

          if (tipoDep === "TITULAR" && vidaIdx === 0) {
            addExcelTitularBarRow(`Titular | ${nomeVida}`, linha);
            linha++;
          }
          if (
            tipoDep === "DEPENDENTE" &&
            (vidaIdx === 0 || this.getTipoVida(grupo.vidas[vidaIdx - 1]) === "TITULAR")
          ) {
            addExcelLabelRow("Dependente(s):", linha);
            linha++;
          }

          setRowValues(linha, [formatarTextoLeitura(this.getTextoCabecalhoVida(vida)), "", "", ""]);

          // Barra VIDA sempre cinza (igual ao CDL Saúde), tanto titular quanto dependente
          for (let col = 1; col <= 4; col++) {
            const cell = sheet.getCell(linha, col);
            cell.font = { bold: true, size: 12, color: { argb: REPORT_COLORS.excelWhite } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: REPORT_COLORS.excelDependente } };
            cell.alignment = { horizontal: "left", vertical: "center" };
            cell.border = this.excelBorder();
          }

          sheet.mergeCells(linha, 1, linha, 4);
          linha++;

          setRowValues(linha, ["Serviço", "Qtd", "Unitário", "Subtotal"]);
          styleRowTableHeader(linha);
          linha++;

          const usos = this.filtrarVidas(vida.codvida);
          let tQtdVida = 0;
          let tVlrVida = 0;

          usos.forEach(uso => {
            const qtd = Number(uso.quantidade) || 1;
            const valorTotal = Number(uso.vlrtotal) || 0;
            tQtdVida += qtd;
            tVlrVida += valorTotal;

            setRowValues(linha, [
              formatarTextoLeitura(this.getNomeServico(uso)),
              qtd,
              Number(uso.vlrunitario) || 0,
              valorTotal
            ]);
            styleRowBody(linha);
            formatQuantity(sheet.getCell(`B${linha}`));
            formatMoney(sheet.getCell(`C${linha}`));
            formatMoney(sheet.getCell(`D${linha}`));
            linha++;
          });

          setRowValues(linha, ["Subtotal", tQtdVida, "-", tVlrVida]);
          styleRowTotal(linha);
          formatQuantity(sheet.getCell(`B${linha}`));
          formatMoney(sheet.getCell(`D${linha}`));
          linha++;
        });

        const totaisGrupo = this.calcularTotalUtilizacoesGrupo(grupo);

        setRowValues(linha, [
          `Total utilizações titular (${formatarTextoLeitura(this.getNomeTitularGrupo(grupo))})`,
          "",
          "",
          totaisGrupo.valorTotal
        ]);

        for (let col = 1; col <= 4; col++) {
          const cell = sheet.getCell(linha, col);
          cell.font = { bold: true, color: { argb: REPORT_COLORS.excelWhite } };
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: REPORT_COLORS.excelBlue } };
          cell.alignment = { horizontal: col === 1 ? "left" : "center", vertical: "center" };
          cell.border = this.excelBorder();
        }

        sheet.mergeCells(linha, 1, linha, 3);
        formatMoney(sheet.getCell(`D${linha}`));
        linha++;

        if (grupoIndex < this.gruposFamiliaSelecionados.length - 1) {
          addBlankRow(linha);
          linha++;
        }
      });

      setRowValues(linha, [
        "Total do associado",
        "",
        "",
        Number(this.totalResumo.valor_total || this.total) || 0
      ]);
      styleRowTotal(linha);
      sheet.getCell(`A${linha}`).font.size = 12;
      formatMoney(sheet.getCell(`D${linha}`));
      linha++;

      setRowValues(linha, ["* Esse relatório não possui validade para fins de Imposto de Renda.", "", "", ""]);
      for (let col = 1; col <= 4; col++) {
        const cell = sheet.getCell(linha, col);
        cell.font = { italic: true, size: 10, color: { argb: "FF666666" } };
        cell.alignment = { horizontal: "left", vertical: "center" };
      }

      // Padroniza a fonte para Arial (igual ao CDL Saúde)
      sheet.eachRow({ includeEmpty: false }, (row) => {
        row.eachCell({ includeEmpty: false }, (cell) => {
          cell.font = Object.assign({}, cell.font, { name: "Arial", size: cell.font && cell.font.size ? cell.font.size : 11 });
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const nomeArquivo = `extrato_utilizacoes_beneficiario_${dataArquivo}.xlsx`;

      return { blob, nomeArquivo };
    }
  },

  created() {
    this.getRelatorio();
    this.carregarResumoUtilizacoesApi();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";

$azul-institucional: #004E9A;
$azul-claro-fundo: #EBF2F9;
$azul-borda: #DBE9F7;
$texto-escuro: #222222;

.title-blue {
  color: $azul-institucional !important;
}

.grupo-familia-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  padding: 24px;
  margin-bottom: 40px;
  border: 1px solid $azul-borda;
}

.total-utilizacoes-titular-vidas {
  display: grid;
  grid-template-columns: 1fr 220px;
  align-items: center;
  gap: 0;
  width: 100%;
  background-color: $azul-institucional;
  color: #ffffff;
  border: 1px solid $azul-institucional;
  border-top: none;
  font-weight: 800;
  text-transform: uppercase;
  margin-top: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.total-utilizacoes-titular-vidas > div {
  padding: 10px 12px;
  border-right: 1px solid $azul-borda;
}

.total-utilizacoes-titular-vidas > div:last-child {
  border-right: none;
}

.total-utilizacoes-titular-qtd,
.total-utilizacoes-titular-valor {
  text-align: center;
}

.bg-vida-header {
  width: 100%;
  min-height: 34px;
  border-radius: 0;
}

.bg-vida-header-titular {
  background-color: #546E7A;
  color: #ffffff;
}

.bg-vida-header-dependente {
  background-color: #546E7A;
  color: #ffffff;
}

.vida-grupo-titular-label {
  font-weight: 800;
  font-size: 14px;
  background-color: $azul-institucional;
  color: #ffffff;
  text-transform: uppercase;
  padding: 8px 16px;
  min-height: 34px;
  display: flex;
  align-items: center;
}

.vida-grupo-dependente-label {
  font-weight: 800;
  font-size: 13px;
  color: $azul-institucional;
  text-transform: uppercase;
  padding: 14px 0 4px 0;
  border-top: 1px solid $azul-borda;
  margin-top: 12px;
}

.vida-header-text {
  font-size: 14px;
  line-height: 1.2;
}

.vida-header-card {
  font-size: 13px;
  line-height: 1.2;
}

.vida-table-shell {
  width: 100%;
  overflow-x: auto;
}

.vida-table-inner {
  width: 100%;
  min-width: 720px;
}

.lista-vida {
  width: 100%;
}

.lista-vida /deep/ table,
.vida-table-inner /deep/ table {
  width: 100% !important;
  min-width: 720px;
  margin-top: 0 !important;
  border-collapse: collapse;
}

.lista-vida /deep/ thead th,
.vida-table-inner /deep/ thead th {
  background-color: $azul-claro-fundo !important;
  color: $azul-institucional !important;
  border: 1px solid $azul-borda !important;
  font-weight: 800;
  text-transform: uppercase;
  vertical-align: middle;
}

.lista-vida /deep/ tbody td,
.vida-table-inner /deep/ tbody td {
  border: 1px solid $azul-borda !important;
  color: $texto-escuro;
  vertical-align: middle;
}

.lista-vida /deep/ tfoot td,
.vida-table-inner /deep/ tfoot td,
::v-deep .lista-vida tfoot td,
::v-deep .vida-table-inner tfoot td {
  background-color: $azul-claro-fundo !important;
  color: $azul-institucional !important;
  border: 1px solid $azul-borda !important;
  font-weight: 800;
}

.lista-vida /deep/ table,
.vida-table-inner /deep/ table,
::v-deep .lista-vida table,
::v-deep .vida-table-inner table {
  margin-bottom: 0 !important;
}

.vida-grupo-shell {
  width: 100%;
}

.vida-table-shell+.vida-table-shell .vida-table-inner {
  margin-top: 0 !important;
}

.vida-table-shell+.vida-table-shell {
  margin-top: 0 !important;
}

.gap-2 {
  gap: 0.5rem;
}

.table-resumo {
  border: 1px solid $azul-borda;

  .thead-blue th {
    background-color: $azul-claro-fundo;
    color: $azul-institucional;
    font-weight: 800;
    font-size: 13px;
    border: 1px solid $azul-borda;
    vertical-align: middle;
    text-transform: uppercase;
  }

  td {
    color: $texto-escuro;
    font-weight: 500;
    font-size: 13px;
    text-transform: uppercase;
    border: 1px solid $azul-borda;
    vertical-align: middle;
  }

  .tfoot-light-blue td {
    background-color: $azul-claro-fundo;
    color: $azul-institucional;
    font-weight: 800;
    border: 1px solid $azul-borda;
  }
}

.table-vida {
  border: 1px solid $azul-borda;

  th {
    background-color: $azul-claro-fundo;
    color: $azul-institucional;
    border: 1px solid $azul-borda;
    font-weight: 800;
    text-transform: uppercase;
    vertical-align: middle;
  }

  td {
    border: 1px solid $azul-borda;
    color: $texto-escuro;
    vertical-align: middle;
    text-transform: uppercase;
  }

  tfoot td {
    background-color: $azul-claro-fundo;
    color: $azul-institucional;
    font-weight: 800;
  }
}

.message-box {
  display: flex;
  background-color: #f8f9fa;
  padding: 20px;
  margin-bottom: 20px;
  width: calc(100% - 20px);
}

.alert {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
}

.message {
  margin: 0;
  padding: 5px 0;
}

.report-logo {
  width: 200px;
  height: auto;
  margin-right: 0;
  mix-blend-mode: multiply;
}

.vidas-lista /deep/ {
  .v-select {
    .vs__dropdown-toggle {
      border-radius: 6px;
      background: white;
      border-bottom: none !important;
      height: 45px;
      display: flex;
      align-items: center;
      position: relative;

      .vs__selected {
        position: absolute;
        left: 10px;
        top: 14px;
      }

      .vs__selected-options {
        width: calc(100% - 40px);

        input {
          width: 100%;
          border: none;
          height: 40px;
          padding: 5px 15px;
        }
      }

      .vs__actions {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        cursor: pointer;

        .vs__clear {
          background: transparent;
          border: none;
          margin-left: -20px;
          margin-right: 10px;
        }
      }
    }

    .vs__dropdown-menu {
      background: white;
      border: none;
      padding: 10px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;

      li {
        padding-top: 5px;
        padding-bottom: 5px;
        cursor: pointer;

        &:hover {
          color: black;
          font-weight: 700;
        }
      }
    }

    &.vs--open {
      .vs__dropdown-toggle {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}

.vidas-lista /deep/ .vs--searching .vs__selected,
.vidas-lista /deep/ .vs--open .vs__selected,
::v-deep .vidas-lista .vs--searching .vs__selected,
::v-deep .vidas-lista .vs--open .vs__selected {
  display: none !important;
}

.vidas-lista /deep/ .vs__search,
::v-deep .vidas-lista .vs__search {
  min-width: 100% !important;
}

.vidas-lista /deep/ .vs__selected-options,
::v-deep .vidas-lista .vs__selected-options {
  overflow: hidden;
}

.btn-voltar {
  color: $azul-institucional;
  font-weight: 700;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
}

.title {
  font-weight: 700;
  font-size: 22px;
}

.flex-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: 900;
  text-align: left;
}

h3.subtitle {
  font-size: 1.4rem;
  font-weight: 700;
  color: $azul-institucional;
}

.rel-value {
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  color: #000;
}

.rel-title {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 10px;
}

.rel-value-reg {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}

#relcontainer table {
  width: 100%;
  margin-top: 0;
}

td {
  font-size: 0.8rem;
}

.rel-block {
  width: 100%;
  border-radius: 5px 0;
  background: #fff;
  margin: 25px 15px 15px 15px;
}

.modal-envio-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal-envio-card {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.modal-envio-header {
  background: $azul-institucional;
  color: #ffffff;
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    margin: 0;
    font-weight: 800;
    text-transform: uppercase;
    font-size: 16px;
  }
}

.modal-envio-close {
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  font-weight: 700;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.modal-envio-body {
  padding: 20px;
  color: #222222;
  font-size: 14px;
}

.modal-envio-footer {
  padding: 14px 18px;
  background: #f8f9fa;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media (max-width: 768px) {

  .vida-table-inner,
  .lista-vida /deep/ table,
  .vida-table-inner /deep/ table {
    min-width: 720px;
  }
}
</style>
